/* KR Phase 4 - drag-to-dismiss on the cart drawer.
   Wraps Minimog's <m-cart-drawer>; it does not replace any of its logic. During a drag we
   own .m-cart-drawer__inner's transform, and on release we either spring back or hand off
   to the element's own close(). Listeners sit on <m-cart-drawer> itself, which survives the
   section re-render that swaps out .m-cart-drawer__inner after every cart update. */
(function () {
  var drawer = document.querySelector('m-cart-drawer');
  if (!drawer || !window.PointerEvent) return;

  var CLAIM = 10;      // px of horizontal travel before we take the gesture
  var DECEL = 0.998;   // scroll-style deceleration (Designing Fluid Interfaces)
  var SCRIM = 0.5;     // the value the theme's own open() writes to --m-bg-opacity

  function project(v) { return (v / 1000) * DECEL / (1 - DECEL); }
  function rubberband(over, dim) {
    var c = 0.55;
    return (over * dim * c) / (dim + c * Math.abs(over));
  }

  var inner = null, W = 1, x = 0, v = 0, raf = null;
  var down = false, claimed = false, owning = false, sx = 0, sy = 0, grab = 0, hist = [];

  function paint() {
    inner.style.transform = 'translate3d(' + x.toFixed(2) + 'px,0,0)';
    drawer.style.setProperty('--m-bg-opacity', (SCRIM * Math.max(0, 1 - x / W)).toFixed(3));
  }

  /* Order matters: close() must set --translate-x to 100% BEFORE the inline transform is
     cleared, otherwise the stylesheet briefly resolves the still-open value and the drawer
     snaps back open for a frame. Transition stays off until the transform is handed back. */
  function finish(to) {
    if (to === W) {
      if (typeof drawer.close === 'function') drawer.close();
      inner.style.transform = '';
    } else {
      inner.style.transform = '';
      drawer.style.setProperty('--m-bg-opacity', String(SCRIM));
    }
    inner.style.transition = '';
    claimed = false;
    owning = false;
  }

  function spring(to, v0) {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var damp = reduce ? 1 : 0.8;          // bounce only because the gesture carried momentum
    var resp = reduce ? 0.2 : 0.3;
    var w = 2 * Math.PI / resp, k = w * w, c = 2 * damp * w, last = performance.now();
    v = v0;
    cancelAnimationFrame(raf);
    raf = requestAnimationFrame(function step(now) {
      var dt = Math.min((now - last) / 1000, 1 / 30);
      last = now;
      v += (-k * (x - to) - c * v) * dt;
      x += v * dt;
      if (Math.abs(x - to) < 0.5 && Math.abs(v) < 10) { x = to; paint(); finish(to); return; }
      paint();
      raf = requestAnimationFrame(step);
    });
  }

  drawer.addEventListener('pointerdown', function (e) {
    if (e.pointerType === 'mouse' && e.button !== 0) return;
    inner = drawer.querySelector('.m-cart-drawer__inner');
    if (!inner || !e.target.closest || !e.target.closest('.m-cart-drawer__inner')) return;
    cancelAnimationFrame(raf);          // interruptible: grabbing mid-flight keeps the position
    if (!owning) x = 0;
    down = true; claimed = false; v = 0;
    sx = e.clientX; sy = e.clientY;
    W = inner.offsetWidth || 1;
    hist = [{ x: e.clientX, t: e.timeStamp }];
  });

  drawer.addEventListener('pointermove', function (e) {
    if (!down) return;
    var dx = e.clientX - sx, dy = e.clientY - sy;
    if (!claimed) {
      if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > CLAIM) { down = false; return; }
      if (Math.abs(dx) < CLAIM) return;
      claimed = true; owning = true;
      grab = e.clientX - x;             // 1:1 from where they grabbed, no jump on claim
      inner.style.transition = 'none';
      /* Throws NotFoundError if the pointer was released between this move and now. Losing
         capture only costs us tracking outside the element; the gesture still completes. */
      try { drawer.setPointerCapture(e.pointerId); } catch (err) {}
    }
    var raw = e.clientX - grab;
    x = raw < 0 ? rubberband(raw, W) : Math.min(raw, W);   // resist being pulled past open
    hist.push({ x: e.clientX, t: e.timeStamp });
    if (hist.length > 6) hist.shift();
    paint();
  });

  function end() {
    if (!down) return;
    down = false;
    if (!claimed) return;
    var a = hist[0], b = hist[hist.length - 1], dt = (b.t - a.t) / 1000;
    var vel = dt > 0.004 ? (b.x - a.x) / dt : 0;
    spring((x + project(vel)) > W * 0.5 ? W : 0, vel);     // snap nearest the PROJECTED point
  }
  drawer.addEventListener('pointerup', end);
  drawer.addEventListener('pointercancel', end);

  /* A drag that ends over the scrim would otherwise also trigger the theme's
     click-outside-to-close, closing the drawer the user just snapped back open. */
  drawer.addEventListener('click', function (e) {
    if (claimed || owning) { e.stopPropagation(); e.preventDefault(); }
  }, true);
})();
